import { render, staticRenderFns } from "./GardenerProvisionedOrders.vue?vue&type=template&id=11b20b1c"
import script from "./GardenerProvisionedOrders.vue?vue&type=script&lang=js"
export * from "./GardenerProvisionedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports